import React, { PureComponent } from "react";

import { Query } from "react-apollo";
import styled from "styled-components";
import { find } from "lodash";

import cityQuery from "../../queries/cityQuery.gql";
import MapView from "../City/MapView";
import Loading from "../../components/Loading/Loading";
import Header from "../../components/Header/Header";

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0;
  left: 0;
  height: 630px;
  width: 1200px;
  overflow: hidden;
`;

const CityWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 2;
`;

class CityShare extends PureComponent {
  state = {
    value: "",

    city: null
  };

  render() {
    const { match } = this.props;

    return (
      <PageWrapper>
        <Query query={cityQuery} variables={{ slug: match.params.city }}>
          {({ loading, error, data }) => {
            if (loading || !data) return <Loading text="City query" />;

            const city = data.cityBySlug;
            this.setState({ city });
            const emojis = [];
            const allEmojis = [];
            const parties = [];
            let party = null;

            city.parties.forEach(p => {
              if (!find(parties, { name: p.name })) {
                parties.push(p);
              }
              p.emojis.forEach(emoji => {
                emojis.push({
                  party: p.name,
                  partySlug: p.slug,
                  citySlug: city.slug,
                  color: p.color,
                  ...emoji
                });
                allEmojis.push(emoji);
              });
            });

            return (
              <CityWrapper id="shareEl">
                <MapView
                  city={city}
                  party={party}
                  emojis={emojis}
                  allEmojis={allEmojis}
                  isFiltered={false}
                  selectedEmoji={null}
                />
                <Header title={`MNM Kieskaart`} hideMenu={true} />
              </CityWrapper>
            );
          }}
        </Query>
      </PageWrapper>
    );
  }
}

export default CityShare;



// WEBPACK FOOTER //
// ./src/pages/Share/City.js